/* eslint-disable */
import React, { useEffect } from "react";

import Header from "components/Common/Header/Header";
import ProjectGanttBody from "components/ProjectManagementComponents/ProjectDetailsComponents/ProjectTaskComponents/ProjectTaskGanttBody/ProjectTaskGanttBody";

const ProjectGanttView = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Project Management";
  }, []);
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="projects" />

      {/* ------ body section -------- */}
      <ProjectGanttBody />
    </main>
  );
};

export default ProjectGanttView;
